import { exec } from "jadelet"
export default exec(["option",{"value":{"bind":"value"}},[{"bind":"text"}]])